// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//     const [email, setEmail] = useState('');
//     const [hoveredSocial, setHoveredSocial] = useState(null);

//     const handleSubscribe = (e) => {
//         e.preventDefault();
//         alert(`Subscribed successfully with: ${email}`);
//         setEmail('');
//     };

//     // Synchronized Pastel Design Theme Tokens
//     const theme = {
//         bg: '#F8F6F2',           // Soft Alabaster White
//         surface: '#FFFFFF',      // Pure Container White
//         textMain: '#2C302E',     // Deep Charcoal
//         textMuted: '#7A827E',    // Soft Muted Sage Grey
//         accent: '#D4AF37',       // Champagne Gold Accent
//         border: 'rgba(44, 48, 46, 0.12)', // Clean horizontal rule styling
//         subFooterBg: '#1A1C1B'   // Premium dark bottom banner matching your reference
//     };

//     return (
//         <footer style={{
//             background: theme.bg,
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             width: '100%',
//             marginTop: 'auto'
//         }}>
//             {/* Upper Thick Section Rule Line */}
//             <div style={{ height: '1px', background: theme.border, width: '100%' }} />

//             {/* Main Content Columns Block */}
//             <div style={{
//                 padding: '60px 80px 40px 80px',
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 justifyContent: 'space-between',
//                 gap: '40px'
//             }}>

//                 {/* COLUMN 1: ADDRESS */}
//                 <div style={{ flex: '1', minWidth: '220px' }}>
//                     <h4 style={{
//                         fontSize: '0.85rem',
//                         fontWeight: '600',
//                         textTransform: 'uppercase',
//                         letterSpacing: '3px',
//                         color: theme.textMain,
//                         marginBottom: '20px'
//                     }}>
//                         ADDRESS
//                     </h4>
//                     <p style={{ fontSize: '0.95rem', color: theme.textMuted, lineHeight: '1.6', margin: '0 0 15px 0' }}>
//                         Main Baner-Sus Road, Complex Block B,<br />
//                         Sus, Pune, Maharashtra 411021, India<br />



//                     </p>
//                     <p style={{ fontSize: '0.95rem', color: theme.textMuted, margin: '0 0 25px 0' }}>
//                         +91 93590009527
//                     </p>
//                     <a
//                         href="google.com"
//                         target="_blank"
//                         rel="noreferrer"
//                         style={{
//                             fontSize: '0.95rem',
//                             fontWeight: '700',
//                             color: theme.textMain,
//                             textDecoration: 'none',
//                             borderBottom: `2px solid ${theme.textMain}`,
//                             paddingBottom: '2px',
//                             transition: 'color 0.2s'
//                         }}
//                         onMouseEnter={(e) => e.target.style.color = theme.accent}
//                         onMouseLeave={(e) => e.target.style.color = theme.textMain}
//                     >
//                         Visit Us
//                     </a>
//                 </div>

//                 {/* COLUMN 2: OPEN HOURS & BRAND */}
//                 <div style={{ flex: '1', minWidth: '220px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//                     <div>
//                         <h4 style={{
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                             letterSpacing: '3px',
//                             color: theme.textMain,
//                             marginBottom: '20px'
//                         }}>
//                             OPEN HOURS
//                         </h4>
//                         <p style={{ fontSize: '0.95rem', color: theme.textMuted, margin: '0' }}>
//                             Monday - Friday: 10am - 7pm
//                         </p>
//                     </div>

//                     {/* <div style={{
//                         fontSize: '1.1rem',
//                         fontWeight: '700',
//                         letterSpacing: '1px',
//                         color: theme.textMain,
//                         marginTop: '40px',
//                         borderBottom: `1px solid ${theme.border}`,
//                         paddingBottom: '8px',
//                         width: 'fit-content'
//                     }}>
//                         Contemporary Corners
//                     </div> */}
//                 </div>

//                 {/* COLUMN 3: SOCIAL SYSTEMS */}
//                 <div style={{ flex: '0.8', minWidth: '150px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: '25px', paddingTop: '35px' }}>
//                     {/* Facebook Link Node */}
//                     <a
//                         href="https://facebook.com"
//                         target="_blank"
//                         rel="noreferrer"
//                         onMouseEnter={() => setHoveredSocial('fb')}
//                         onMouseLeave={() => setHoveredSocial(null)}
//                         style={{
//                             textDecoration: 'none',
//                             fontSize: '1.6rem',
//                             fontWeight: 'bold',
//                             color: hoveredSocial === 'fb' ? theme.accent : theme.textMain,
//                             transition: 'transform 0.2s, color 0.2s',
//                             transform: hoveredSocial === 'fb' ? 'scale(1.15)' : 'scale(1)',
//                             display: 'inline-block'
//                         }}
//                     >
//                         f
//                     </a>

//                     {/* Instagram Link Node */}
//                     <a
//                         href="https://instagram.com"
//                         target="_blank"
//                         rel="noreferrer"
//                         onMouseEnter={() => setHoveredSocial('ig')}
//                         onMouseLeave={() => setHoveredSocial(null)}
//                         style={{
//                             textDecoration: 'none',
//                             fontSize: '1.6rem',
//                             fontWeight: 'bold',
//                             color: hoveredSocial === 'ig' ? theme.accent : theme.textMain,
//                             transition: 'transform 0.2s, color 0.2s',
//                             transform: hoveredSocial === 'ig' ? 'scale(1.15)' : 'scale(1)',
//                             display: 'inline-block',
//                             // lineHeight: '1.6rem'
//                         }}
//                     >
//                         I
//                     </a>
//                 </div>

//                 {/* COLUMN 4: SUBSCRIBE PANEL */}
//                 <div style={{ flex: '1.2', minWidth: '280px' }}>
//                     <h4 style={{
//                         fontSize: '0.85rem',
//                         fontWeight: '600',
//                         textTransform: 'uppercase',
//                         letterSpacing: '3px',
//                         color: theme.textMain,
//                         marginBottom: '20px'
//                     }}>
//                         SUBSCRIBE
//                     </h4>
//                     <form onSubmit={handleSubscribe} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                         <input
//                             type="email"
//                             required
//                             placeholder="Email"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             style={{
//                                 width: '100%',
//                                 padding: '14px 18px',
//                                 background: 'rgba(44, 48, 46, 0.03)',
//                                 border: `1px solid ${theme.border}`,
//                                 color: theme.textMain,
//                                 fontSize: '0.95rem',
//                                 outline: 'none',
//                                 boxSizing: 'border-box',
//                                 transition: 'border-color 0.2s'
//                             }}
//                             onFocus={(e) => e.target.style.borderColor = theme.textMain}
//                             onBlur={(e) => e.target.style.borderColor = theme.border}
//                         />
//                         <button
//                             type="submit"
//                             style={{
//                                 width: '100%',
//                                 padding: '14px',
//                                 background: theme.textMain, // Solid Charcoal matching reference block
//                                 color: '#FFFFFF',
//                                 border: 'none',
//                                 fontSize: '0.95rem',
//                                 fontWeight: '600',
//                                 letterSpacing: '1px',
//                                 cursor: 'pointer',
//                                 transition: 'opacity 0.2s'
//                             }}
//                             onMouseEnter={(e) => e.target.style.opacity = '0.9'}
//                             onMouseLeave={(e) => e.target.style.opacity = '1'}
//                         >
//                             Subscribe
//                         </button>
//                     </form>
//                 </div>

//             </div>

//             {/* ==================== BOTTOM DEEP SUB-FOOTER BANNER ==================== */}
//             <div style={{
//                 background: theme.subFooterBg,
//                 padding: '15px 20px',
//                 textAlign: 'center',
//                 fontSize: '0.8rem',
//                 letterSpacing: '1px',
//                 color: 'rgba(255, 255, 255, 0.5)'
//             }}>
//                 {/* The code below dynamically pulls the exact current year from the system clock */}
//                 {new Date().getFullYear()} ST INTERIOR STUDIO | <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Privacy Policy</Link> | <Link to="/terms" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Terms of Use</Link>
//             </div>

//         </footer>
//     );
// };

// export default Footer;

// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../Assets/logo-removebg-preview.png';

// const Footer = () => {
//     const [email, setEmail] = useState('');
//     const [hoveredSocial, setHoveredSocial] = useState(null);

//     const handleSubscribe = (e) => {
//         e.preventDefault();
//         alert(`Subscribed successfully with: ${email}`);
//         setEmail('');
//     };

//     // Synchronized Pastel Design Theme Tokens
//     const theme = {
//         bg: '#FFFFFF',           // Soft Alabaster White
//         surface: '#FFFFFF',      // Pure Container White
//         textMain: '#2C302E',     // Deep Charcoal
//         textMuted: '#7A827E',    // Soft Muted Sage Grey
//         accent: '#D4AF37',       // Champagne Gold Accent
//         border: 'rgba(44, 48, 46, 0.12)', // Clean horizontal rule styling
//         subFooterBg: '#1A1C1B'   // Premium dark bottom banner matching your reference
//     };

//     // Advanced Responsive Layout CSS Injections
//     const inlineResponsiveStyles = `
//     /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
//     @media (max-width: 768px) {
//         .footer-main-columns-container {
//             padding: 40px 20px 30px 20px !important;
//             flex-direction: column !important;
//             gap: 35px !important;
//         }
//         .footer-column-wrapper {
//             min-width: 100% !important;
//             flex: none !important;
//         }
//         .footer-social-wrapper {
//             justify-content: flex-start !important;
//             padding-top: 10px !important;
//         }
//         .sub-footer-text-wrapper {
//             padding: 20px 15px !important;
//             font-size: 0.75rem !important;
//             line-height: 1.6 !important;
//             display: flex !important;
//             flex-direction: column !important;
//             gap: 8px !important;
//         }
//             @keyframes pulseGlow {
//     0%{
//         opacity:0.5;
//         transform:scale(1);
//     }
//     50%{
//         opacity:1;
//         transform:scale(1.1);
//     }
//     100%{
//         opacity:0.5;
//         transform:scale(1);
//     }
// }
//     }
//   `;

//     return (
//         <footer style={{
//             background: theme.bg,
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             width: '100%',
//             marginTop: 'auto'
//         }}>
//             <style>{inlineResponsiveStyles}</style>

//             {/* Upper Thick Section Rule Line */}
//             <div style={{ height: '1px', background: theme.border, width: '100%' }} />

//             {/* Main Content Columns Block */}
//             <div className="footer-main-columns-container" style={{
//                 padding: '50px 70px 30px 70px',
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 justifyContent: 'space-between',
//                 gap: '40px',
//                 transition: 'padding 0.3s ease'
//             }}>

//                 {/* COMPANY LOGO */}

//                 <div
//                     style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '15px',
//                         marginBottom: '30px'
//                     }}
//                 >

//                     <div
//                         style={{
//                             width: '70px',
//                             height: '70px',
//                             borderRadius: '20px',
//                             background: 'rgba(255,255,255,0.7)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             border: `1px solid ${theme.border}`,
//                             boxShadow: '0 15px 35px rgba(0,0,0,0.04)',
//                             position: 'relative',
//                             overflow: 'hidden'
//                         }}
//                     >

//                         {/* GOLD GLOW */}
//                         <div
//                             style={{
//                                 position: 'absolute',
//                                 width: '120%',
//                                 height: '120%',
//                                 borderRadius: '50%',
//                                 background: 'rgba(212,175,55,0.12)',
//                                 animation: 'pulseGlow 5s ease-in-out infinite'
//                             }}
//                         />

//                         <img
//                             src={logo}
//                             alt="ST Interior"
//                             style={{
//                                 width: '45px',
//                                 height: '45px',
//                                 objectFit: 'contain',
//                                 position: 'relative',
//                                 zIndex: 2
//                             }}
//                         />

//                     </div>

//                     <div>

//                         <h2
//                             style={{
//                                 margin: '0',
//                                 color: theme.textMain,
//                                 fontSize: '1.5rem',
//                                 letterSpacing: '2px'
//                             }}
//                         >
//                             ST INTERIOR STUDIO
//                         </h2>


//                         <span
//                             style={{
//                                 color: theme.accent,
//                                 fontSize: '0.75rem',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '3px',
//                                 fontWeight: '600'
//                             }}
//                         >
//                             Luxury Interior Studio
//                         </span>

//                          {/* <span
//                             style={{
//                                 color: theme.accent,
//                                 fontSize: '0.75rem',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '3px',
//                                 fontWeight: '600'
//                             }}
//                         >
//                                Turning Spaces Into Stories
//                         </span> */}



//                     </div>

//                 </div>
//                 {/* COLUMN 1: ADDRESS */}
//                 <div className="footer-column-wrapper" style={{ flex: '1', minWidth: '220px' }}>
//                     <h4 style={{
//                         fontSize: '0.85rem',
//                         fontWeight: '600',
//                         textTransform: 'uppercase',
//                         letterSpacing: '3px',
//                         color: theme.textMain,
//                         marginBottom: '20px'
//                     }}>
//                         ADDRESS
//                     </h4>
//                     <p style={{ fontSize: '0.95rem', color: theme.textMuted, lineHeight: '1.6', margin: '0 0 15px 0' }}>
//                          403 Platinum 9, Pashan-Sus Road, <br />
//                          Behind Audi Showroom, Baner, Pune, MH-411045, INDIA
//                     </p>
//                     <p style={{ fontSize: '0.95rem', color: theme.textMuted, margin: '0 0 25px 0' }}>
//                         <a href="tel:+919359009527" className="contact-link">
//                             +91 93590 09527
//                         </a>
//                     </p>
//                     <a
//                         href="https://maps.app.goo.gl/9ni2MYn5biG2sUiC8"
//                         target="_blank"
//                         rel="noreferrer"
//                         style={{
//                             fontSize: '0.95rem',
//                             fontWeight: '700',
//                             color: theme.textMain,
//                             textDecoration: 'none',
//                             borderBottom: `2px solid ${theme.textMain}`,
//                             paddingBottom: '2px',
//                             transition: 'color 0.2s'
//                         }}
//                         onMouseEnter={(e) => e.target.style.color = theme.accent}
//                         onMouseLeave={(e) => e.target.style.color = theme.textMain}
//                     >
//                         Visit Us
//                     </a>
//                 </div>

//                 {/* COLUMN 2: OPEN HOURS & BRAND */}
//                 {/* <div className="footer-column-wrapper" style={{ flex: '1', minWidth: '220px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//                     <div>
//                         <h4 style={{
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                             letterSpacing: '3px',
//                             color: theme.textMain,
//                             marginBottom: '20px'
//                         }}>
//                             OPEN HOURS
//                         </h4>
//                         <p style={{ fontSize: '0.95rem', color: theme.textMuted, margin: '0' }}>
//                             Monday - Friday: 10am - 7pm
//                         </p>
//                     </div>
//                 </div> */}

//                 {/* COLUMN 3: SOCIAL SYSTEMS */}
//                 <div className="footer-column-wrapper footer-social-wrapper" style={{ flex: '0.8', minWidth: '150px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: '25px', paddingTop: '35px' }}>
//                     {/* Facebook Link Node */}
//                     <a
//                         href="https://facebook.com"
//                         target="_blank"
//                         rel="noreferrer"
//                         onMouseEnter={() => setHoveredSocial('fb')}
//                         onMouseLeave={() => setHoveredSocial(null)}
//                         style={{
//                             textDecoration: 'none',
//                             fontSize: '1.6rem',
//                             fontWeight: 'bold',
//                             color: hoveredSocial === 'fb' ? theme.accent : theme.textMain,
//                             transition: 'transform 0.2s, color 0.2s',
//                             transform: hoveredSocial === 'fb' ? 'scale(1.15)' : 'scale(1)',
//                             display: 'inline-block'
//                         }}
//                     >
//                         f
//                     </a>

//                     {/* Instagram Link Node */}
//                     <a
//                         href="https://www.instagram.com/stinterior_studio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
//                         target="_blank"
//                         rel="noreferrer"
//                         onMouseEnter={() => setHoveredSocial('ig')}
//                         onMouseLeave={() => setHoveredSocial(null)}
//                         style={{
//                             textDecoration: 'none',
//                             fontSize: '1.6rem',
//                             fontWeight: 'bold',
//                             color: hoveredSocial === 'ig' ? theme.accent : theme.textMain,
//                             transition: 'transform 0.2s, color 0.2s',
//                             transform: hoveredSocial === 'ig' ? 'scale(1.15)' : 'scale(1)',
//                             display: 'inline-block'
//                         }}
//                     >
//                         I
//                     </a>
//                 </div>

//                 {/* COLUMN 4: SUBSCRIBE PANEL */}
//                 <div className="footer-column-wrapper" style={{ flex: '1.2', minWidth: '280px' }}>
//                     <h4 style={{
//                         fontSize: '0.85rem',
//                         fontWeight: '600',
//                         textTransform: 'uppercase',
//                         letterSpacing: '3px',
//                         color: theme.textMain,
//                         marginBottom: '20px'
//                     }}>
//                         SUBSCRIBE
//                     </h4>
//                     <form onSubmit={handleSubscribe} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                         <input
//                             type="email"
//                             required
//                             placeholder="Email"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             style={{
//                                 width: '100%',
//                                 padding: '14px 18px',
//                                 background: 'rgba(44, 48, 46, 0.03)',
//                                 border: `1px solid ${theme.border}`,
//                                 color: theme.textMain,
//                                 fontSize: '0.95rem',
//                                 outline: 'none',
//                                 boxSizing: 'border-box',
//                                 transition: 'border-color 0.2s'
//                             }}
//                             onFocus={(e) => e.target.style.borderColor = theme.textMain}
//                             onBlur={(e) => e.target.style.borderColor = theme.border}
//                         />
//                         <button
//                             type="submit"
//                             style={{
//                                 width: '100%',
//                                 padding: '14px',
//                                 background: theme.textMain,
//                                 color: '#FFFFFF',
//                                 border: 'none',
//                                 fontSize: '0.95rem',
//                                 fontWeight: '600',
//                                 letterSpacing: '1px',
//                                 cursor: 'pointer',
//                                 transition: 'opacity 0.2s'
//                             }}
//                             onMouseEnter={(e) => e.target.style.opacity = '0.9'}
//                             onMouseLeave={(e) => e.target.style.opacity = '1'}
//                         >
//                             Subscribe
//                         </button>
//                     </form>
//                 </div>

//             </div>

//             {/* ==================== BOTTOM DEEP SUB-FOOTER BANNER ==================== */}
//             <div className="sub-footer-text-wrapper" style={{
//                 background: theme.subFooterBg,
//                 padding: '5px 20px',
//                 textAlign: 'center',
//                 fontSize: '0.8rem',
//                 letterSpacing: '1px',
//                 color: 'rgba(255, 255, 255, 0.5)'
//             }}>
//                 {new Date().getFullYear()} ST INTERIOR STUDIO | <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Privacy Policy</Link> | <Link to="/terms" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Terms of Use</Link>
//             </div>

//         </footer>
//     );
// };

// export default Footer;


import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/logo-removebg-preview.png';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [hoveredSocial, setHoveredSocial] = useState(null);

    const handleSubscribe = (e) => {
        e.preventDefault();
        alert(`Subscribed successfully with: ${email}`);
        setEmail('');
    };

    // Synchronized Pastel Design Theme Tokens
    const theme = {
        bg: '#FFFFFF',           // Soft Alabaster White
        surface: '#FFFFFF',      // Pure Container White
        textMain: '#2C302E',     // Deep Charcoal
        textMuted: '#7A827E',    // Soft Muted Sage Grey
        accent: '#D4AF37',       // Champagne Gold Accent
        border: 'rgba(44, 48, 46, 0.12)', // Clean horizontal rule styling
        subFooterBg: '#1A1C1B'   // Premium dark bottom banner
    };

    // Advanced Responsive Layout CSS Injections
    const inlineResponsiveStyles = `
    @keyframes pulseGlow {
        0% { opacity: 0.5; transform: scale(1); }
        50% { opacity: 1; transform: scale(1.1); }
        100% { opacity: 0.5; transform: scale(1); }
    }

    /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
    @media (max-width: 991px) {
        .footer-main-columns-container {
            padding: 40px 30px 30px 30px !important;
            flex-direction: column !important;
            gap: 35px !important;
        }
        .footer-column-wrapper {
            width: 100% !important;
            min-width: 100% !important;
            flex: none !important;
        }
        .footer-social-wrapper {
            justify-content: flex-start !important;
            padding-top: 0px !important;
        }
        .sub-footer-text-wrapper {
            padding: 15px 15px !important;
            font-size: 0.75rem !important;
            line-height: 1.6 !important;
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
        }
    }
    `;

    return (
        <footer style={{
            background: theme.bg,
            fontFamily: 'system-ui, -apple-system, sans-serif',
            boxSizing: 'border-box',
            width: '100%',
            marginTop: 'auto'
        }}>
            <style>{inlineResponsiveStyles}</style>

            {/* Upper Section Boundary Line */}
            <div style={{ height: '1px', background: theme.border, width: '100%' }} />

            {/* Main Content Columns Block */}
            <div className="footer-main-columns-container" style={{
                padding: '60px 70px 40px 70px',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '40px',
                boxSizing: 'border-box',
                width: '100%'
            }}>

                {/* COLUMN 1: BRAND IDENTITY & SHORT DESCRIPTION */}
                <div className="footer-column-wrapper" style={{ flex: '1.4', minWidth: '260px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '16px',
                            background: 'rgba(255,255,255,0.7)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: `1px solid ${theme.border}`,
                            boxShadow: '0 10px 25px rgba(0,0,0,0.04)',
                            position: 'relative',
                            overflow: 'hidden',
                            flexShrink: 0
                        }}>
                            {/* GOLD GLOW */}
                            <div style={{
                                position: 'absolute',
                                width: '120%',
                                height: '120%',
                                borderRadius: '50%',
                                background: 'rgba(212,175,55,0.12)',
                                animation: 'pulseGlow 5s ease-in-out infinite'
                            }} />
                            <img
                                src={logo}
                                alt="ST Interior Studio Logo"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    objectFit: 'contain',
                                    position: 'relative',
                                    zIndex: 2
                                }}
                            />
                        </div>

                        <div>
                            <h2 style={{
                                margin: '0',
                                color: theme.textMain,
                                fontSize: '1.3rem',
                                letterSpacing: '2px',
                                fontWeight: '700'
                            }}>
                                ST INTERIOR STUDIO
                            </h2>
                            <span style={{
                                color: theme.accent,
                                fontSize: '0.7rem',
                                textTransform: 'uppercase',
                                letterSpacing: '3px',
                                fontWeight: '600',
                                display: 'block',
                                marginTop: '3px'
                            }}>
                                Luxury Interior Studio
                            </span>
                        </div>
                    </div>

                    {/* COMPANY SHORT DESCRIPTION */}
                    <p style={{
                        fontSize: '0.9rem',
                        color: theme.textMuted,
                        lineHeight: '1.6',
                        margin: '15px 0 0 0',
                        maxWidth: '340px',
                          fontFamily: "'Cormorant Garamond', serif",
                    }}>
                       {/* Designing Experiences, Creating Timeless Spaces. */}
                                     Luxury is not about expensive materials. It is about crafting profound emotions inside a physical space.
                    </p>
                </div>

                {/* COLUMN 2: ADDRESS */}
                <div className="footer-column-wrapper" style={{ flex: '1', minWidth: '220px' }}>
                    <h4 style={{
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '3px',
                        color: theme.textMain,
                        marginBottom: '20px',
                        marginTop: '0'
                    }}>
                        ADDRESS
                    </h4>
                    <p style={{ fontSize: '0.9rem', color: "#1A1C1B", lineHeight: '1.6', margin: '0 0 12px 0' ,   fontFamily: "'Cormorant Garamond', serif",}}>
                        403 Platinum 9, Pashan-Sus Road, <br />
                        Behind Audi Showroom, Baner, Pune, MH-411045, INDIA
                    </p>
                    <p style={{ fontSize: '0.9rem', color: "theme.textMuted", margin: '0 0 20px 0' }}>
                        <a href="tel:+919359009527" style={{ color: "#1A1C1B", textDecoration: 'none',   fontFamily: "'Cormorant Garamond', serif", }}>
                            +91 93590 09527
                        </a>
                    </p>
                    <a
                        href="https://maps.app.goo.gl/9ni2MYn5biG2sUiC8"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            fontSize: '0.85rem',
                            fontWeight: '700',
                            color: theme.textMain,
                            textDecoration: 'none',
                            borderBottom: `2px solid ${theme.textMain}`,
                            paddingBottom: '2px',
                            transition: 'color 0.2s',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}
                        onMouseEnter={(e) => e.target.style.color = theme.accent}
                        onMouseLeave={(e) => e.target.style.color = theme.textMain}
                    >
                        Visit Us
                    </a>
                </div>

                {/* COLUMN 3: SOCIAL LINKS */}
                <div className="footer-column-wrapper footer-social-wrapper" style={{ flex: '0.6', minWidth: '120px' }}>
                    <h4 style={{
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '3px',
                        color: theme.textMain,
                        marginBottom: '20px',
                        marginTop: '0'
                    }}>
                        CONNECT
                    </h4>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                        {/* Facebook */}
                        <a
                            href="https://www.facebook.com/share/14o1GPzVu3o/?mibextid=wwXIfr"
                            target="_blank"
                            rel="noreferrer"
                            onMouseEnter={() => setHoveredSocial('fb')}
                            onMouseLeave={() => setHoveredSocial(null)}
                            style={{
                                textDecoration: 'none',
                                fontSize: '1.4rem',
                                fontWeight: 'bold',
                                color: hoveredSocial === 'fb' ? theme.accent : theme.textMain,
                                transition: 'transform 0.2s, color 0.2s',
                                transform: hoveredSocial === 'fb' ? 'scale(1.15)' : 'scale(1)',
                                display: 'inline-block',
                                
                            }}
                        >
                            f
                        </a>

                        {/* Instagram */}
                        <a
                            href="https://www.instagram.com/stinterior_studio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            target="_blank"
                            rel="noreferrer"
                            onMouseEnter={() => setHoveredSocial('ig')}
                            onMouseLeave={() => setHoveredSocial(null)}
                            style={{
                                textDecoration: 'none',
                                fontSize: '1.4rem',
                                fontWeight: 'bold',
                                color: hoveredSocial === 'ig' ? theme.accent : theme.textMain,
                                transition: 'transform 0.2s, color 0.2s',
                                transform: hoveredSocial === 'ig' ? 'scale(1.15)' : 'scale(1)',
                                display: 'inline-block'
                            }}
                        >
                            I
                        </a>
                    </div>
                </div>

                {/* COLUMN 4: SUBSCRIBE PANEL */}
                <div className="footer-column-wrapper" style={{ flex: '1.1', minWidth: '240px' }}>
                    <h4 style={{
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '3px',
                        color: theme.textMain,
                        marginBottom: '20px',
                        marginTop: '0'
                    }}>
                        SUBSCRIBE
                    </h4>
                    <form onSubmit={handleSubscribe} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <input
                            type="email"
                            required
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                background: 'rgba(44, 48, 46, 0.03)',
                                border: `1px solid ${theme.border}`,
                                color: theme.textMain,
                                fontSize: '0.9rem',
                                outline: 'none',
                                boxSizing: 'border-box',
                                transition: 'border-color 0.2s'
                            }}
                            onFocus={(e) => e.target.style.borderColor = theme.textMain}
                            onBlur={(e) => e.target.style.borderColor = theme.border}
                        />
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '12px',
                                background: theme.textMain,
                                color: '#FFFFFF',
                                border: 'none',
                                fontSize: '0.85rem',
                                fontWeight: '600',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                                transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                            onMouseLeave={(e) => e.target.style.opacity = '1'}
                        >
                            Subscribe
                        </button>
                    </form>
                </div>

            </div>

            {/* ==================== BOTTOM DEEP SUB-FOOTER BANNER ==================== */}
            <div className="sub-footer-text-wrapper" style={{
                background: theme.subFooterBg,
                padding: '12px 20px',
                textAlign: 'center',
                fontSize: '0.8rem',
                letterSpacing: '1px',
                color: 'rgba(255, 255, 255, 0.5)'
            }}>
                © {new Date().getFullYear()} ST INTERIOR STUDIO | <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Privacy Policy</Link> | <Link to="/terms" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Terms of Use</Link>
            </div>

        </footer>
    );
};

export default Footer;


// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// // IMPORT YOUR LOGO
// import logo from '../Assets/logo-removebg-preview.png';

// const Footer = () => {

//     const [email, setEmail] = useState('');
//     const [hoveredSocial, setHoveredSocial] = useState(null);

//     const handleSubscribe = (e) => {
//         e.preventDefault();
//         alert(`Subscribed successfully with: ${email}`);
//         setEmail('');
//     };

//     const theme = {
//         bg: '#F8F6F2',
//         surface: '#FFFFFF',
//         textMain: '#2C302E',
//         textMuted: '#7A827E',
//         accent: '#D4AF37',
//         border: 'rgba(44, 48, 46, 0.12)',
//         subFooterBg: '#1A1C1B'
//     };

//     const inlineResponsiveStyles = `

//     @keyframes fadeUp {
//         from {
//             opacity:0;
//             transform:translateY(60px);
//         }
//         to {
//             opacity:1;
//             transform:translateY(0px);
//         }
//     }

//     @keyframes floatGlow {
//         0% {
//             transform:translateY(0px);
//         }
//         50% {
//             transform:translateY(-20px);
//         }
//         100% {
//             transform:translateY(0px);
//         }
//     }

//     @keyframes pulseGlow {
//         0% {
//             opacity:0.5;
//             transform:scale(1);
//         }
//         50% {
//             opacity:1;
//             transform:scale(1.1);
//         }
//         100% {
//             opacity:0.5;
//             transform:scale(1);
//         }
//     }

//     .footer-animate {
//         animation:fadeUp 1s cubic-bezier(0.16, 1, 0.3, 1);
//     }

//     @media (max-width: 768px) {

//         .footer-main-columns-container {
//             padding: 50px 20px 40px 20px !important;
//             flex-direction: column !important;
//             gap: 45px !important;
//         }

//         .footer-column-wrapper {
//             min-width: 100% !important;
//             flex: none !important;
//         }

//         .footer-social-wrapper {
//             justify-content: flex-start !important;
//             padding-top: 0px !important;
//         }

//         .footer-logo-section {
//             justify-content:flex-start !important;
//         }

//         .sub-footer-text-wrapper {
//             padding: 20px 15px !important;
//             font-size: 0.75rem !important;
//             line-height: 1.6 !important;
//             display: flex !important;
//             flex-direction: column !important;
//             gap: 10px !important;
//         }

//     }

//     `;

//     return (

//         <footer
//             style={{
//                 background: `
//                 radial-gradient(circle at top left, rgba(212,175,55,0.10), transparent 30%),
//                 radial-gradient(circle at bottom right, rgba(44,48,46,0.05), transparent 35%),
//                 ${theme.bg}
//                 `,
//                 fontFamily: 'system-ui, -apple-system, sans-serif',
//                 boxSizing: 'border-box',
//                 width: '100%',
//                 marginTop: 'auto',
//                 overflow: 'hidden',
//                 position: 'relative'
//             }}
//         >

//             <style>{inlineResponsiveStyles}</style>

//             {/* FLOATING ORBS */}

//             <div
//                 style={{
//                     position: 'absolute',
//                     top: '-100px',
//                     right: '-100px',
//                     width: '260px',
//                     height: '260px',
//                     borderRadius: '50%',
//                     background: 'rgba(212,175,55,0.10)',
//                     filter: 'blur(70px)',
//                     animation: 'floatGlow 8s ease-in-out infinite'
//                 }}
//             />

//             <div
//                 style={{
//                     position: 'absolute',
//                     bottom: '-120px',
//                     left: '-120px',
//                     width: '300px',
//                     height: '300px',
//                     borderRadius: '50%',
//                     background: 'rgba(44,48,46,0.06)',
//                     filter: 'blur(80px)',
//                     animation: 'floatGlow 10s ease-in-out infinite'
//                 }}
//             />

//             {/* Top Divider */}

//             <div
//                 style={{
//                     height: '1px',
//                     background: theme.border,
//                     width: '100%'
//                 }}
//             />

//             {/* MAIN CONTENT */}

//             <div
//                 className="footer-main-columns-container footer-animate"
//                 style={{
//                     padding: '70px 80px 50px 80px',
//                     display: 'flex',
//                     flexWrap: 'wrap',
//                     justifyContent: 'space-between',
//                     gap: '40px',
//                     position: 'relative',
//                     zIndex: 2
//                 }}
//             >

//                 {/* COLUMN 1 */}

//                 <div
//                     className="footer-column-wrapper"
//                     style={{
//                         flex: '1',
//                         minWidth: '240px'
//                     }}
//                 >

//                     {/* LOGO */}

//                     <div
//                         className="footer-logo-section"
//                         style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '18px',
//                             marginBottom: '30px'
//                         }}
//                     >

//                         <div
//                             style={{
//                                 width: '75px',
//                                 height: '75px',
//                                 borderRadius: '22px',
//                                 background: 'rgba(255,255,255,0.7)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 backdropFilter: 'blur(20px)',
//                                 border: `1px solid ${theme.border}`,
//                                 boxShadow: '0 20px 40px rgba(0,0,0,0.04)',
//                                 position: 'relative',
//                                 overflow: 'hidden'
//                             }}
//                         >

//                             <div
//                                 style={{
//                                     position: 'absolute',
//                                     width: '120%',
//                                     height: '120%',
//                                     background: 'rgba(212,175,55,0.10)',
//                                     borderRadius: '50%',
//                                     animation: 'pulseGlow 5s ease-in-out infinite'
//                                 }}
//                             />

//                             <img
//                                 src={logo}
//                                 alt="ST Interior"
//                                 style={{
//                                     width: '48px',
//                                     height: '48px',
//                                     objectFit: 'contain',
//                                     position: 'relative',
//                                     zIndex: 2
//                                 }}
//                             />

//                         </div>

//                         <div>

//                             <h2
//                                 style={{
//                                     margin: '0',
//                                     color: theme.textMain,
//                                     letterSpacing: '2px',
//                                     fontSize: '1.5rem'
//                                 }}
//                             >
//                                 ST INTERIOR
//                             </h2>

//                             <span
//                                 style={{
//                                     color: theme.accent,
//                                     fontSize: '0.75rem',
//                                     textTransform: 'uppercase',
//                                     letterSpacing: '3px',
//                                     fontWeight: '600'
//                                 }}
//                             >
//                                 Luxury Studio
//                             </span>

//                         </div>

//                     </div>

//                     <h4
//                         style={{
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                             letterSpacing: '3px',
//                             color: theme.textMain,
//                             marginBottom: '20px'
//                         }}
//                     >
//                         ADDRESS
//                     </h4>

//                     <p
//                         style={{
//                             fontSize: '0.95rem',
//                             color: theme.textMuted,
//                             lineHeight: '1.9',
//                             margin: '0 0 15px 0'
//                         }}
//                     >
//                         Main Baner-Sus Road, Complex Block B,
//                         Sus, Pune, Maharashtra 411021, India
//                     </p>

//                     <p
//                         style={{
//                             fontSize: '0.95rem',
//                             color: theme.textMuted,
//                             margin: '0 0 25px 0'
//                         }}
//                     >
//                         +91 93590009527
//                     </p>

//                     <a
//                         href="https://google.com"
//                         target="_blank"
//                         rel="noreferrer"
//                         style={{
//                             fontSize: '0.95rem',
//                             fontWeight: '700',
//                             color: theme.textMain,
//                             textDecoration: 'none',
//                             borderBottom: `2px solid ${theme.textMain}`,
//                             paddingBottom: '4px',
//                             transition: '0.4s'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.color = theme.accent;
//                             e.target.style.borderColor = theme.accent;
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.color = theme.textMain;
//                             e.target.style.borderColor = theme.textMain;
//                         }}
//                     >
//                         Visit Our Studio
//                     </a>

//                 </div>

//                 {/* COLUMN 2 */}

//                 <div
//                     className="footer-column-wrapper"
//                     style={{
//                         flex: '1',
//                         minWidth: '220px'
//                     }}
//                 >

//                     <h4
//                         style={{
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                             letterSpacing: '3px',
//                             color: theme.textMain,
//                             marginBottom: '20px'
//                         }}
//                     >
//                         OPEN HOURS
//                     </h4>

//                     <p
//                         style={{
//                             fontSize: '0.95rem',
//                             color: theme.textMuted,
//                             marginBottom: '15px'
//                         }}
//                     >
//                         Monday - Friday: 10am - 7pm
//                     </p>

//                     <p
//                         style={{
//                             fontSize: '0.95rem',
//                             color: theme.textMuted
//                         }}
//                     >
//                         Saturday: 11am - 5pm
//                     </p>

//                 </div>

//                 {/* COLUMN 3 */}

//                 <div
//                     className="footer-column-wrapper footer-social-wrapper"
//                     style={{
//                         flex: '0.8',
//                         minWidth: '150px',
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'flex-start',
//                         gap: '20px',
//                         paddingTop: '35px'
//                     }}
//                 >

//                     {[
//                         { id: 'fb', label: 'f' },
//                         { id: 'ig', label: '◎' },
//                         { id: 'ln', label: 'in' }
//                     ].map((social) => (

//                         <a
//                             key={social.id}
//                             href="/"
//                             onMouseEnter={() =>
//                                 setHoveredSocial(social.id)
//                             }
//                             onMouseLeave={() =>
//                                 setHoveredSocial(null)
//                             }
//                             style={{
//                                 width: '55px',
//                                 height: '55px',
//                                 borderRadius: '50%',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 textDecoration: 'none',
//                                 fontWeight: '700',
//                                 fontSize: '1.1rem',
//                                 background:
//                                     hoveredSocial === social.id
//                                         ? theme.textMain
//                                         : 'rgba(255,255,255,0.7)',
//                                 color:
//                                     hoveredSocial === social.id
//                                         ? '#fff'
//                                         : theme.textMain,
//                                 border: `1px solid ${theme.border}`,
//                                 transition: '0.4s',
//                                 transform:
//                                     hoveredSocial === social.id
//                                         ? 'translateY(-8px) scale(1.08)'
//                                         : 'translateY(0px) scale(1)',
//                                 boxShadow:
//                                     hoveredSocial === social.id
//                                         ? '0 20px 40px rgba(0,0,0,0.10)'
//                                         : '0 10px 30px rgba(0,0,0,0.03)'
//                             }}
//                         >
//                             {social.label}
//                         </a>

//                     ))}

//                 </div>

//                 {/* COLUMN 4 */}

//                 <div
//                     className="footer-column-wrapper"
//                     style={{
//                         flex: '1.2',
//                         minWidth: '280px'
//                     }}
//                 >

//                     <h4
//                         style={{
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                             letterSpacing: '3px',
//                             color: theme.textMain,
//                             marginBottom: '20px'
//                         }}
//                     >
//                         SUBSCRIBE
//                     </h4>

//                     <form
//                         onSubmit={handleSubscribe}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             gap: '14px'
//                         }}
//                     >

//                         <input
//                             type="email"
//                             required
//                             placeholder="Your Email Address"
//                             value={email}
//                             onChange={(e) =>
//                                 setEmail(e.target.value)
//                             }
//                             style={{
//                                 width: '100%',
//                                 padding: '16px 20px',
//                                 background: 'rgba(255,255,255,0.7)',
//                                 border: `1px solid ${theme.border}`,
//                                 color: theme.textMain,
//                                 fontSize: '0.95rem',
//                                 outline: 'none',
//                                 borderRadius: '14px',
//                                 backdropFilter: 'blur(20px)',
//                                 transition: '0.4s'
//                             }}
//                         />

//                         <button
//                             type="submit"
//                             style={{
//                                 width: '100%',
//                                 padding: '16px',
//                                 background: theme.textMain,
//                                 color: '#FFFFFF',
//                                 border: 'none',
//                                 borderRadius: '14px',
//                                 fontSize: '0.95rem',
//                                 fontWeight: '600',
//                                 letterSpacing: '2px',
//                                 cursor: 'pointer',
//                                 transition: '0.4s',
//                                 boxShadow: '0 20px 40px rgba(0,0,0,0.08)'
//                             }}
//                             onMouseEnter={(e) => {
//                                 e.target.style.background = theme.accent;
//                                 e.target.style.transform = 'translateY(-4px)';
//                             }}
//                             onMouseLeave={(e) => {
//                                 e.target.style.background = theme.textMain;
//                                 e.target.style.transform = 'translateY(0px)';
//                             }}
//                         >
//                             SUBSCRIBE
//                         </button>

//                     </form>

//                 </div>

//             </div>

//             {/* SUB FOOTER */}

//             <div
//                 className="sub-footer-text-wrapper"
//                 style={{
//                     background: theme.subFooterBg,
//                     padding: '18px 20px',
//                     textAlign: 'center',
//                     fontSize: '0.8rem',
//                     letterSpacing: '1px',
//                     color: 'rgba(255, 255, 255, 0.5)'
//                 }}
//             >

//                 © {new Date().getFullYear()} ST INTERIOR STUDIO |
//                 <Link
//                     to="/privacy"
//                     style={{
//                         color: 'rgba(255,255,255,0.5)',
//                         textDecoration: 'none',
//                         margin: '0 10px'
//                     }}
//                 >
//                     Privacy Policy
//                 </Link>

//                 |

//                 <Link
//                     to="/terms"
//                     style={{
//                         color: 'rgba(255,255,255,0.5)',
//                         textDecoration: 'none',
//                         margin: '0 10px'
//                     }}
//                 >
//                     Terms of Use
//                 </Link>

//             </div>

//         </footer>

//     );
// };

// export default Footer;